var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "191px",
    height: "191px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.833333333333332,26.833333333333332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 39,
    height: 39,
    fill: "#b3aba9"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1.4492753623188404s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.4347826086956521s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.16666666666667,26.833333333333332)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 39,
    height: 39,
    fill: "#f8ee6a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1.4492753623188404s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.2898550724637681s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.833333333333332,73.16666666666667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 39,
    height: 39,
    fill: "#f8ee6a"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1.4492753623188404s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "0s"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.16666666666667,73.16666666666667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -19.5,
    width: 39,
    height: 39,
    fill: "#b3aba9"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    dur: "1.4492753623188404s",
    keyTimes: "0;1",
    values: "1.1500000000000001;1",
    begin: "-0.14492753623188406s"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPino);
export default __webpack_public_path__ + "static/media/pino.d617036f76f457452fcf516d0030ff43.svg";
export { ForwardRef as ReactComponent };